import Image, { ImageProps } from 'next/image';
import { forwardRef, useState, useEffect } from 'react';

export const myLoader = ({ src }: { src: string }) => {
  return src;
};

// Definimos uma interface que aceita props legadas para não quebrar os componentes pais
interface BPImageProps extends Omit<ImageProps, 'src'> {
  src: any;
  fallbackSrc?: string;
  layout?: 'fill' | 'fixed' | 'intrinsic' | 'responsive';
  objectFit?: React.CSSProperties['objectFit'];
  objectPosition?: React.CSSProperties['objectPosition'];
}

const BPImage = forwardRef<HTMLImageElement, BPImageProps>((props, ref) => {
  const {
    src,
    fallbackSrc,
    layout,
    objectFit,
    objectPosition,
    style,
    fill,
    width,
    height,
    ...rest
  } = props;

  const [imgSrc, set_imgSrc] = useState(src);

  // Sincroniza o estado se a imagem mudar (ex: navegar entre produtos)
  useEffect(() => {
    set_imgSrc(src);
  }, [src]);

  // Lógica de Tradução: Legacy -> Modern Next.js 14
  const isFill = layout === 'fill' || fill;

  const modernStyle: React.CSSProperties = {
    ...style,
    // Aplicamos width 100% apenas se for explicitamente responsive
    ...(layout === 'responsive' ? { width: '100%', height: 'auto' } : {}),
    // Passamos o objectFit e Position para o objeto style (padrão Next 14)
    ...(objectFit ? { objectFit } : {}),
    ...(objectPosition ? { objectPosition } : {}),
  };

  return (
    <Image
      {...rest} // Contém props como className, priority, quality, etc.
      ref={ref}
      src={imgSrc || '/img/placeholder.svg'}
      alt={rest.alt || ''}
      unoptimized
      loader={myLoader}

      // CONFIGURAÇÃO DE DIMENSÕES (A correção está aqui)
      fill={isFill}
      // Se NÃO for fill, passamos o width/height recebidos. Se for fill, passamos undefined.
      width={!isFill ? (Number(width) || undefined) : undefined}
      height={!isFill ? (Number(height) || undefined) : undefined}

      style={modernStyle}
      onError={() => {
        if (fallbackSrc && imgSrc !== fallbackSrc) {
          set_imgSrc(fallbackSrc);
        }
      }}
    />
  );
});

BPImage.displayName = 'BPImage';

export default BPImage;
